// eslint-disable-next-line no-empty-pattern
const GroupField = ({}) => null;

GroupField.propTypes = {};

export default GroupField;
